import { useState } from 'react';
import { putData } from '../api/apiService';

export const usePatch = () => {
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const putRequest = async (endpoint, requestData) => {
		setLoading(true);
		try {
			const { data } = await putData(endpoint, requestData);
			setData(data);
		} catch (error) {
			setError(error);
		} finally {
			setLoading(false);
		}
	};

	return { data, loading, error, putRequest };
};
